export const VEBEnrollmentNext = {
	Cancer: "Whole life",
	"Whole life": "Short Term Disability",
	"Short Term Disability": "Critical Illness",
	"Critical Illness": "Hospital Indemnity",
	"Hospital Indemnity": "Accident",
	Accident: "Group Life Indemnity",
	"Group Life Indemnity": "Family Protection",
	"Family Protection": "Doc and Rx",
	"Doc and Rx": "Vision",
	Vision: "Dental",
	Dental: "finish"
};

export const VEBEnrollmentArray = [
	"Cancer",
	"Whole life",
	"Short Term Disability",
	"Critical Illness",
	"Hospital Indemnity",
	"Accident",
	"Group Life Indemnity",
	"Family Protection",
	"Doc and Rx",
	"Vision",
	"Dental"
];

export const NEXT_CURRENT_VEB_ENROLLMENT_CAPTIONS = {
	Cancer: {
		previousPlanCaption: null,
		nextPlanCaption: "Whole Life"
	},
	"Whole life": {
		previousPlanCaption: "Cancer",
		nextPlanCaption: "S-T-D"
	},
	"Short Term Disability": {
		previousPlanCaption: "Whole Life",
		nextPlanCaption: "Critical Illness"
	},
	"Critical Illness": {
		previousPlanCaption: "S-T-D",
		nextPlanCaption: "Hospital"
	},
	"Hospital Indemnity": {
		previousPlanCaption: "Critical Illness",
		nextPlanCaption: "Accident"
	},
	Accident: {
		previousPlanCaption: "Hospital",
		nextPlanCaption: "G-L-I"
	},
	"Group Life Indemnity": {
		previousPlanCaption: "Accident",
		nextPlanCaption: "Family Protection"
	},
	"Family Protection": {
		previousPlanCaption: "G-L-I",
		nextPlanCaption: "Doc & Rx"
	},
	"Doc and Rx": {
		previousPlanCaption: "Family Protection",
		nextPlanCaption: "Vision"
	},
	Vision: {
		previousPlanCaption: "Doc & Rx",
		nextPlanCaption: "Dental"
	},
	Dental: {
		previousPlanCaption: "Vision",
		nextPlanCaption: "Finish"
	}
};
